// extracted by mini-css-extract-plugin
module.exports = {"root":"dashed-button_root__cXra7"};